module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-32.d59b5dab.png";